import React, { useEffect, useState } from 'react';
import {
 batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';
import { useSnackbar } from 'notistack';

import Text from '../../Text/Text';
import { accounts, marketplaces } from '../newOrderStepperData';
import { setCreateNewOrderData } from '../../../thunks/coilovers/orders/createNewOrder';
import Input from '../../Input/Input';
import StepperNavigationBtn from './StepperNavigationBtn';
import getOrderByPo, { clearErrorGetOrderByPo } from '../../../thunks/general/getOrderByPo';
import coOrderAssemblyType from '../../../constants/coOrderAssemblyType';

const OrderMarketplaceForm = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [timer, setTimer] = useState();
  const {
    createNewOrderData: {
      marketplace,
      account,
      referenceNo,
    },
    getOrderByPo: {
      loading,
      orderData,
      error,
    }
  } = useSelector((state) => ({
    createNewOrderData: state.createNewOrder?.data,
    getOrderByPo: state.getOrderByPo
  }), shallowEqual);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: 'warning' });
      dispatch(clearErrorGetOrderByPo());
    }
  }, [error]);

  useEffect(() => {
    if (referenceNo?.length > 2) {
      clearTimeout(timer);
      const t = setTimeout(() => batch(() => {
        dispatch(getOrderByPo(referenceNo));
      }), 1000);
      setTimer(t);
    }
  }, [referenceNo]);

  useEffect(() => {
    if (orderData?.hasFCSItem) {
      enqueueSnackbar('FCS item(s) found in order. Order will set to Reassembly style', {
        variant: 'warning',
        autoHideDuration: 5000
      });
      dispatch(setCreateNewOrderData({
        order_assembly_style: coOrderAssemblyType.REASSEMBLY
      }));
    }
  }, [orderData?.hasFCSItem]);

  return (
    <div className="flex flex-col flex-1">
      <div className="pb-[50px]">
        <Text text="Setup Marketplace" textStyle="text-[20px] text-[#252F4A] mb-[6px]" />
      </div>
      <div>
        <div className="mb-[30px]">
          <Text
            text="Reference no"
            textStyle="text-[#252F4A] text-[14px]"
            styleContainer="mb-[10px]"
            tooltip="Type reference number for load reference order data"
          />
          <Input
            type="text"
            name="reference_no"
            value={referenceNo || orderData?.order_po_number || ''}
            placeholder="Reference no"
            onChange={({ target: { value } }) => dispatch(setCreateNewOrderData({ referenceNo: value }))}
          />
        </div>
        <div className="mb-[30px]">
          <Text
            text="Marketplace"
            textStyle="text-[#252F4A] text-[14px]"
            styleContainer="mb-[10px]"
          />
          <div className="flex flex-row gap-[20px]">
            {marketplaces?.map(({ name, id }) => (
              <div
                role="presentation"
                onClick={() => dispatch(setCreateNewOrderData({ marketplace: name }))}
                key={id}
                className={`cursor-pointer p-[14px] border border-dashed border-[#DBDFE9] rounded-[10px]
                text-[16px] text-center flex-1 flex items-center justify-center
                ${marketplace === name ? 'border-[#3E97FF] bg-[#f1faff] text-[#3E97FF]' : ''}`}
              >
                {name}
              </div>
            ))}
          </div>
        </div>
        <div className="mb-[30px]">
          <Text
            text="Account"
            textStyle="text-[#252F4A] text-[14px]"
            styleContainer="mb-[10px]"
          />
          <div className="flex flex-row gap-[20px]">
            {accounts[marketplace]?.map(({ name, id }) => (
              <div
                role="presentation"
                onClick={() => dispatch(setCreateNewOrderData({ account: name }))}
                key={id}
                className={`cursor-pointer p-[14px] border border-dashed border-[#DBDFE9] rounded-[10px]
                text-[16px] text-center flex-1 flex items-center justify-center
                ${account === name ? 'border-[#3E97FF] bg-[#f1faff] text-[#3E97FF]' : ''}`}
              >
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
      <StepperNavigationBtn next="details" disabledNext={loading} loading={loading} />
    </div>
  );
};

export default OrderMarketplaceForm;
